/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { useGetRetailerByClientQuery, useGetUserInfoQuery } from '../../API/authApi';

export const useGetCompanyInfoSelector = () => {
    const { companyInfo } = useGetUserInfoQuery(undefined, {
        selectFromResult: ({ data }) => ({
            companyInfo: data && data.user.companyInfo,
        }),
    });

    return companyInfo;
};

export const useGetUserInfoSelector = () => {
    const { userInfo } = useGetUserInfoQuery(undefined, {
        selectFromResult: ({ data }) => {
            return {
                userInfo: data && data.user.userInfo,
            };
        },
    });

    return userInfo;
};

export const useGetUserSelector = () => {
    const { userInfo } = useGetUserInfoQuery(undefined, {
        selectFromResult: ({ data }) => {
            return {
                userInfo: data && data.user.user,
            };
        },
    });

    return userInfo;
};

export const useGetUserToolsSelector = () => {
    const { userInfo } = useGetUserInfoQuery(undefined, {
        selectFromResult: ({ data }) => {
            return {
                userInfo: data && data.user.tools,
            };
        },
    });

    return userInfo;
};

export const useGetAvailableLangsSelector = () => {
    const { langs } = useGetRetailerByClientQuery(undefined, {
        selectFromResult: ({ data }) => {
            const langSet = new Set<string>();
            data?.data.forEach((r) => {
                r.languages.forEach((l) => langSet.add(l));
            });

            return { langs: Array.from(langSet) };
        },
    });

    return langs;
};

export const useGetAuthorizedTabsSelector = (): { authorizedTabs: string[]; isLoading: boolean } => {
    const userInfo = useGetUserInfoSelector();
    const { authorizedTabs, isLoading } = useGetUserInfoQuery(undefined, {
        selectFromResult: ({ data }) => {
            const authorizedTabs = data ? data.user.authorizedTabs.map((t) => t.name) : [];
            if (authorizedTabs.includes('cdm_colors')) authorizedTabs.push('cdm_preferences');
            if (authorizedTabs.includes('cdm_clientsproduct')) authorizedTabs.push('products');
            if (authorizedTabs.includes('cdm_producttitlesplit')) authorizedTabs.push('cdm_clientsproduct');
            if (userInfo && userInfo.user_groups.includes(17)) authorizedTabs.push('cdm_international_company_groups');
            return {
                authorizedTabs,
                isLoading: !data,
            };
        },
    });
    return { authorizedTabs, isLoading };
};

export const useGetKeywordsLimits = () => {
    const keywordsLimit = useGetUserInfoQuery(undefined, {
        selectFromResult: ({ data }) => {
            const { companyInfo } = data!.user;
            return {
                searchLimit: companyInfo?.search_keyword_limit,
                bannerLimit: companyInfo?.banners_keyword_limit,
                masterSearchLimit: companyInfo?.master_search_keyword_limit,
                masterBannersLimit: companyInfo?.master_banners_keyword_limit,
            };
        },
    });

    return keywordsLimit;
};
